/* globals Class,jui,lp */

module.exports = Class.create(
  lp.editor.panel.ElementPropertiesPanel,
  lp.editor.panel.ElementGeometryControls,
  lp.ModuleComponent,
  {
    type:'lp-multi-select',

    installUI: function($super){
      $super();

      var geometryPanel = this.insert(new jui.CollapsiblePanel({
        title:'Geometry',
        attributes: {
          className: 'collapsible-panel panel-multiselect-geometry'
        }
      }));
      this.installGeometryControls({insert:geometryPanel.insertContent.bind(geometryPanel)});
    },

    syncUIControls: function($super, elm) {
      $super(elm);
      this.bindGeometryControlsToElement(elm);
    }
  }
);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-multi-select/multi_select_element_properties_panel.js
// module id = 1486
// module chunks = 0